import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import { pushClickToDL } from '../ComplexTabsList.datalayer';

enum Selectors {
  CTA = 'a',
  Tab = '.gtm-tab',
  CTA_Event = 'button.MuiButton-root',
}

export const mapTabbedCardTarget = mapTargetBySelectors([
  Selectors.Tab,
  Selectors.CTA,
  Selectors.CTA_Event,
]);
export const onDataLayerTabbedCardClick = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const isTab = target?.classList.contains(Selectors.Tab.replace('.', ''));

  if (isTab) {
    const title = target?.querySelector('.heading')?.textContent || '';
    return pushClickToDL({ title, target });
  }

  const tabIndex = target?.closest('[data-tab-index]').getAttribute('data-tab-index');
  const cardTitle =
    target?.closest('.tabbed-card').querySelector('.tabbed-card-heading').textContent || '';
  return pushClickToDL({ title: cardTitle, target, indexNum: tabIndex });
};
